import { d } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var s = {
  name: "bo",
  weekdays: "གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split("_"),
  weekdaysShort: "ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),
  weekdaysMin: "ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),
  months: "ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),
  monthsShort: "ཟླ་དང་པོ_ཟླ་གཉིས་པ_ཟླ་གསུམ་པ_ཟླ་བཞི་པ_ཟླ་ལྔ་པ_ཟླ་དྲུག་པ_ཟླ་བདུན་པ_ཟླ་བརྒྱད་པ_ཟླ་དགུ་པ_ཟླ་བཅུ་པ_ཟླ་བཅུ་གཅིག་པ_ཟླ་བཅུ་གཉིས་པ".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "A h:mm",
    LTS: "A h:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY, A h:mm",
    LLLL: "dddd, D MMMM YYYY, A h:mm"
  },
  relativeTime: {
    future: "%s ལ་",
    past: "%s སྔོན་ལ་",
    s: "ཏོག་ཙམ་",
    m: "སྐར་མ་གཅིག་",
    mm: "སྐར་མ་ %d",
    h: "ཆུ་ཚོད་གཅིག་",
    hh: "ཆུ་ཚོད་ %d",
    d: "ཉིན་གཅིག་",
    dd: "ཉིན་ %d",
    M: "ཟླ་བ་གཅིག་",
    MM: "ཟླ་བ་ %d",
    y: "ལོ་གཅིག་",
    yy: "ལོ་ %d"
  }
};
d.locale(s, null, !0);
export {
  s as default
};
